<template>
    <v-card elevation="15" style="background-color:#1B437C">
      <v-container>
        <v-row>
          <v-spacer></v-spacer>
          <v-col>
      <v-menu
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="picker"
            prepend-icon="mdi-calendar"
            color="blue darken-2"
            readonly
            v-bind="attrs"
            v-on="on"
            dark
            width='400'
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="picker"
          dark
          @input="menu2 = false"
          type="month"
          this.picker ="picker"
          @change="selectDate(picker)"
        ></v-date-picker>
      </v-menu>
      </v-col>
      <v-spacer></v-spacer>
        </v-row>
        <v-card img-bottom>
          <ChartLineBase width='1248' height='648' :chart-data="chartData" />
        </v-card>
      </v-container>
    </v-card>
</template>

<script>
import ChartLineBase from './ChartLineAllActivityMemberjoinBase'
import axios from 'axios'
import Vue from 'vue'
import VueSweetAlert from 'vue-sweetalert'

Vue.use(VueSweetAlert)

export default {
  components: {
    ChartLineBase
  },
  form: [],
  data () {
    return {
      session: this.$session.getAll(),
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).slice(0, 7),
      btn: [
        { label: 'Today', value: 'day' },
        { label: 'This Week', value: 'week' }
      ],
      chartData: null,
      data: {
        // day: [1, 3, 5, 3, 1],
        week: Array(31).fill(0)
      },
      labels: {
        // day: [8, 10, 12, 14, 16],
        week: []
      },
      radio: 'week'
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.selectDate(this.picker)
    console.log(this.session.data.shopId)
  },
  methods: {
    async selectDate (Date) {
      this.data.week = Array(31).fill(0)
      console.log(Date)
      this.labels.week = []
      const year = Date.split('-')[0]
      const month = Date.split('-')[1]
      let day = this.daysInMonth(month, year)
      for (var i = 0; i < day; i++) {
        var data = {}
        data.date = (i + 101).toString().substr(1, 2) + '/' + month + '/' + year
        data.dateLabels = (i + 101).toString().substr(1, 2)
        this.labels.week.push(data.dateLabels)
      }
      await axios.get(this.DNS_IP + '/all-member-join/get?shopId=' + this.session.data.shopId + '&date=' + Date)
        .then(async (response) => {
          let rs = response.data
          if (response.data.status === false) {
            this.data.week = Array(31).fill(0)
            this.fillData()
          } else {
            for (let i = 0; i < rs.length; i++) {
              var d = rs[i]
              this.data.week[parseInt(d.joinDate.slice(8, 10)) - 1] = d.total
            }
            this.fillData()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    fillData () {
      this.chartData = {
        labels: this.labels[this.radio],
        datasets: [
          {
            borderColor: false,
            data: this.data[this.radio],
            tension: 0.1,
            label: 'Member',
            backgroundColor: '#CDF0EA'
          }
        ]
      }
    },
    daysInMonth (month, year) {
      return new Date(year, month, 0).getDate()
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ReportActivity/CharLineAllActivityMemberjoin.vue